var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9974 0.664062C6.6374 0.664062 0.664062 6.6374 0.664062 13.9974C0.664062 21.3574 6.6374 27.3307 13.9974 27.3307C21.3574 27.3307 27.3307 21.3574 27.3307 13.9974C27.3307 6.6374 21.3574 0.664062 13.9974 0.664062ZM10.3841 19.7174L6.78406 16.5441C6.26406 16.0241 6.26406 15.1841 6.78406 14.6641C7.30406 14.1441 8.14406 14.1441 8.66406 14.6641L11.3307 16.8907L18.1174 9.9974C18.6374 9.4774 19.4774 9.4774 19.9974 9.9974C20.5174 10.5174 20.5174 11.3574 19.9974 11.8774L12.2641 19.7174C11.7574 20.2374 10.9041 20.2374 10.3841 19.7174Z",
    fill: "#008446"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.e913af6050ebdb7a19c112868a72270e.svg";
export { ForwardRef as ReactComponent };